module.exports = __webpack_public_path__ + "images/emoji/boot.aeb749b78ea0cb1e88fd.png";